<div class="delivery-page">
  <header class="delivery-header">
    <div class="header-info">
      <button mat-button type="button" [routerLink]="backLink" [queryParams]="backQueryParams">
        <mat-icon>arrow_back</mat-icon>
        {{ wh?.provider?.description || 'Поставщик' }}
      </button>
      <h1>
        Доставка — {{ wh?.description || 'Склад' }}
        <span class="header-city">{{ wh?.city?.description || '' }}</span>
      </h1>
    </div>

    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="!canEdit || !!validationError"
      (click)="save()"
    >
      <mat-icon>save</mat-icon>
      Сохранить
    </button>
  </header>

  <nav
    mat-tab-nav-bar
    [tabPanel]="receiverPanel"
    class="receiver-tabs"
    aria-label="Наш склад — получатель"
  >
    <button
      type="button"
      mat-tab-link
      *ngFor="let receiver of receiverWarehouses"
      [active]="receiver.id === receiverWarehouseId"
      [disabled]="loading || saving || switching"
      (click)="selectReceiver(receiver.id)"
      [title]="
        receiver.description + (receiver.city?.description ? ' — ' + receiver.city.description : '')
      "
    >
      <mat-icon>warehouse</mat-icon>
      {{ receiver.description }}
    </button>
  </nav>
  <mat-tab-nav-panel #receiverPanel>
    <div
      class="receiver-status"
      aria-live="polite"
      *ngIf="loading || loadError || !receiverWarehouseId"
    >
      <span *ngIf="loading">Загрузка…</span>
      <span *ngIf="!loading && !receiverWarehouseId && !loadError"
        >Выберите склад получения, чтобы настроить доставку.</span
      >
      <span *ngIf="loadError" class="load-error">{{ loadError }}</span>
      <button
        *ngIf="loadError && receiverWarehouses.length"
        mat-button
        type="button"
        (click)="retryLoad()"
      >
        Повторить
      </button>
    </div>
    <div class="copy-route">
      <mat-form-field appearance="outline"
        ><mat-label>Скопировать настройки со склада</mat-label>
        <mat-select [(ngModel)]="copyReceiverId" [disabled]="!canEdit"
          ><ng-container *ngFor="let receiver of receiverWarehouses">
            <mat-option *ngIf="receiver.id !== receiverWarehouseId" [value]="receiver.id">{{
              receiver.description
            }}</mat-option>
          </ng-container></mat-select
        >
      </mat-form-field>
      <button
        mat-stroked-button
        type="button"
        [disabled]="!canEdit || !copyReceiverId"
        (click)="copyRoute()"
      >
        <mat-icon>content_copy</mat-icon> Копировать в текущий склад
      </button>
      <span
        >Время прибытия и дорога задаются для {{ receiverWarehouse?.description }}. Время —
        Киев.</span
      >
    </div>
    <p class="validation-error" role="alert" *ngIf="validationError">{{ validationError }}</p>
    <main class="delivery-layout">
      <fieldset class="delivery-card" [disabled]="!canEdit" [attr.inert]="!canEdit ? '' : null">
        <!-- Своя доставка -->
        <div class="delivery-method" [class.method-on]="ownEnabled">
          <div class="method-head">
            <mat-checkbox [ngModel]="ownEnabled" (ngModelChange)="toggleOwn($event)">
              <mat-icon class="method-icon">local_shipping</mat-icon>
              Доставка со склада
            </mat-checkbox>
            <span class="method-hint">свой транспорт: заказ до отсечки → приезд через N дней</span>
          </div>

          <div class="method-body" *ngIf="ownEnabled">
            <div
              class="delivery-rule"
              *ngFor="let rule of ownRules; let i = index; trackBy: trackByIndex"
            >
              <mat-button-toggle-group
                multiple
                class="days-toggle"
                [ngModel]="rule.days"
                (ngModelChange)="rule.days = $event"
              >
                <mat-button-toggle *ngFor="let day of weekdays" [value]="day.value">
                  {{ day.label }}
                </mat-button-toggle>
              </mat-button-toggle-group>

              <div class="chip-field">
                <app-delivery-time-input
                  class="time-field"
                  label="Заказ до"
                  [(value)]="rule.cutoff"
                  [disabled]="!canEdit"
                ></app-delivery-time-input>
              </div>

              <mat-form-field appearance="outline" class="offset-field"
                ><mat-label>День прибытия</mat-label>
                <mat-select [(ngModel)]="rule.arrivalDayOffset"
                  ><mat-option *ngFor="let offset of arrivalOffsets" [value]="offset.value">{{
                    offset.label
                  }}</mat-option></mat-select
                >
              </mat-form-field>
              <mat-form-field appearance="outline" class="offset-field"
                ><mat-label>Дни доставки</mat-label>
                <mat-select
                  multiple
                  [(ngModel)]="rule.arrivalDays"
                  placeholder="Каждый день"
                  title="Если дни не выбраны, доставка возможна каждый день"
                  ><mat-option *ngFor="let day of weekdays" [value]="day.value">{{
                    day.label
                  }}</mat-option></mat-select
                >
              </mat-form-field>
              <div class="chip-field">
                <app-delivery-time-input
                  class="time-field"
                  label="Приезд с"
                  [(value)]="rule.arrivalFrom"
                  [disabled]="!canEdit"
                ></app-delivery-time-input>

                <app-delivery-time-input
                  class="time-field"
                  label="Приезд до"
                  [(value)]="rule.arrivalTo"
                  [disabled]="!canEdit"
                ></app-delivery-time-input>
              </div>

              <button
                mat-icon-button
                class="rule-remove"
                type="button"
                aria-label="Удалить правило"
                title="Удалить правило"
                (click)="removeOwnRule(i)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="method-footer">
              <button
                mat-button
                color="primary"
                class="add-rule"
                type="button"
                (click)="addOwnRule()"
              >
                <mat-icon>add</mat-icon>
                Добавить правило
              </button>
              <span class="method-hint">Для одних дней можно задать несколько отсечек.</span>
            </div>
          </div>
        </div>

        <!-- Перевозчик -->
        <div class="delivery-method" [class.method-on]="carrierEnabled">
          <div class="method-head">
            <mat-checkbox [ngModel]="carrierEnabled" (ngModelChange)="toggleCarrier($event)">
              <mat-icon class="method-icon">local_post_office</mat-icon>
              Перевозчик
            </mat-checkbox>
            <span class="method-hint">Новая почта и т.п.: отправка при заказе до отсечки</span>
          </div>

          <div class="method-body" *ngIf="carrierEnabled">
            <div
              class="delivery-rule"
              *ngFor="let rule of carrierRules; let i = index; trackBy: trackByIndex"
            >
              <mat-button-toggle-group
                multiple
                class="days-toggle"
                [ngModel]="rule.days"
                (ngModelChange)="rule.days = $event"
              >
                <mat-button-toggle *ngFor="let day of weekdays" [value]="day.value">
                  {{ day.label }}
                </mat-button-toggle>
              </mat-button-toggle-group>

              <div class="chip-field" *ngIf="i === 0">
                <span class="chip-label">Служба</span>
                <div class="chip">
                  <input
                    class="chip-text"
                    type="text"
                    placeholder="Новая почта"
                    [(ngModel)]="carrierName"
                  />
                </div>
              </div>

              <div class="chip-field">
                <app-delivery-time-input
                  class="time-field"
                  label="Заказ до"
                  [(value)]="rule.cutoff"
                  [disabled]="!canEdit"
                ></app-delivery-time-input>
              </div>

              <div class="chip-field">
                <span class="chip-label">Отправка</span>
                <div class="chip chip-select">
                  <select [(ngModel)]="rule.shipDayOffset">
                    <option *ngFor="let offset of arrivalOffsets" [ngValue]="offset.value">
                      {{ offset.label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="chip-field">
                <span class="chip-label">В пути</span>
                <div class="chip">
                  <input class="chip-num" type="number" min="0" [(ngModel)]="rule.transitDays" />
                  <span class="chip-unit">дн.</span>
                </div>
              </div>

              <button
                mat-icon-button
                class="rule-remove"
                type="button"
                aria-label="Удалить правило"
                title="Удалить правило"
                (click)="removeCarrierRule(i)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="method-footer">
              <button
                mat-button
                color="primary"
                class="add-rule"
                type="button"
                (click)="addCarrierRule()"
              >
                <mat-icon>add</mat-icon>
                Другие дни
              </button>
              <span class="overlap-warning" *ngIf="duplicateDaysLabel(carrierRules) as warning">
                <mat-icon>warning</mat-icon>
                {{ warning }}
              </span>
            </div>
          </div>
        </div>

        <!-- Рейсы по городу -->
        <div class="delivery-method" [class.method-on]="runsEnabled">
          <div class="method-head">
            <mat-checkbox [ngModel]="runsEnabled" (ngModelChange)="toggleRuns($event)">
              <mat-icon class="method-icon">departure_board</mat-icon>
              Рейсы по городу
            </mat-checkbox>
            <span class="method-hint">заказать до → отправление → прибытие на выбранный склад</span>
          </div>

          <div class="method-body" *ngIf="runsEnabled">
            <div
              class="delivery-rule"
              *ngFor="let rule of runsRules; let i = index; trackBy: trackByIndex"
            >
              <mat-button-toggle-group
                multiple
                class="days-toggle"
                [ngModel]="rule.days"
                (ngModelChange)="rule.days = $event"
              >
                <mat-button-toggle *ngFor="let day of weekdays" [value]="day.value">
                  {{ day.label }}
                </mat-button-toggle>
              </mat-button-toggle-group>

              <app-delivery-time-input
                class="time-field"
                label="Заказать до"
                [(value)]="rule.cutoff"
                [disabled]="!canEdit"
              ></app-delivery-time-input
              ><app-delivery-time-input
                class="time-field"
                label="Отправление"
                [(value)]="rule.departures[0]"
                [disabled]="!canEdit"
              ></app-delivery-time-input
              ><mat-form-field appearance="outline" class="offset-field"
                ><mat-label>День прибытия</mat-label
                ><mat-select [(ngModel)]="rule.arrivalDayOffset"
                  ><mat-option *ngFor="let offset of arrivalOffsets" [value]="offset.value">{{
                    offset.label
                  }}</mat-option></mat-select
                ></mat-form-field
              ><app-delivery-time-input
                class="time-field"
                label="Прибытие с"
                [(value)]="rule.arrivalFrom"
                [disabled]="!canEdit"
              ></app-delivery-time-input
              ><app-delivery-time-input
                class="time-field"
                label="Прибытие до"
                [(value)]="rule.arrivalTo"
                [disabled]="!canEdit"
              ></app-delivery-time-input
              ><mat-form-field appearance="outline" class="number-field"
                ><mat-label>Или в пути, мин</mat-label
                ><input matInput type="number" [(ngModel)]="rule.transitMinutes" min="1" max="1440"
              /></mat-form-field>
              <button
                mat-icon-button
                class="rule-remove"
                type="button"
                aria-label="Удалить правило"
                title="Удалить правило"
                (click)="removeRunsRule(i)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="method-footer">
              <button
                mat-button
                color="primary"
                class="add-rule"
                type="button"
                (click)="addRunsRule()"
              >
                <mat-icon>add</mat-icon>
                Добавить рейс
              </button>
              <span class="overlap-warning" *ngIf="duplicateDaysLabel(runsRules) as warning">
                <mat-icon>warning</mat-icon>
                {{ warning }}
              </span>
            </div>
          </div>
        </div>

        <!-- Самовывоз -->
        <div class="delivery-method" [class.method-on]="pickupEnabled">
          <div class="method-head">
            <mat-checkbox [ngModel]="pickupEnabled" (ngModelChange)="togglePickup($event)">
              <mat-icon class="method-icon">storefront</mat-icon>
              Самовывоз
            </mat-checkbox>
            <span class="method-hint">можно забрать со склада самостоятельно</span>
          </div>

          <div class="method-body" *ngIf="pickupEnabled">
            <div class="pickup-logistics">
              <mat-form-field appearance="outline" class="logistics-field"
                ><mat-label>Дорога в одну сторону, мин</mat-label
                ><input
                  matInput
                  type="number"
                  [(ngModel)]="pickupTravelMinutes"
                  min="0"
                  max="1440"
                  step="1" /></mat-form-field
              ><mat-form-field appearance="outline" class="logistics-field"
                ><mat-label>Подготовка и выдача, мин</mat-label
                ><input
                  matInput
                  type="number"
                  [(ngModel)]="pickupHandlingMinutes"
                  min="0"
                  max="1440"
                  step="1" /></mat-form-field
              ><mat-form-field appearance="outline" class="number-field"
                ><mat-label>Расстояние, км</mat-label
                ><input
                  matInput
                  type="number"
                  [(ngModel)]="pickupDistanceKm"
                  min="0"
                  max="2000"
                  step="0.1" /></mat-form-field
              ><mat-form-field appearance="outline" class="address-field"
                ><mat-label>Адрес / ориентир</mat-label
                ><input matInput type="text" [(ngModel)]="pickupAddress" maxlength="500"
              /></mat-form-field>
            </div>
            <span class="method-hint"
              >Получение у нас = дорога туда + выдача + дорога обратно. Заполните время и график для
              расчёта.</span
            >
            <div
              class="delivery-rule"
              *ngFor="let rule of pickupRules; let i = index; trackBy: trackByIndex"
            >
              <mat-button-toggle-group
                multiple
                class="days-toggle"
                [ngModel]="rule.days"
                (ngModelChange)="rule.days = $event"
              >
                <mat-button-toggle *ngFor="let day of weekdays" [value]="day.value">
                  {{ day.label }}
                </mat-button-toggle>
              </mat-button-toggle-group>

              <div class="chip-field">
                <app-delivery-time-input
                  class="time-field"
                  label="Самовывоз с"
                  [(value)]="rule.from"
                  [disabled]="!canEdit"
                ></app-delivery-time-input>

                <app-delivery-time-input
                  class="time-field"
                  label="Самовывоз до"
                  [(value)]="rule.to"
                  [disabled]="!canEdit"
                ></app-delivery-time-input>
              </div>

              <button
                mat-icon-button
                class="rule-remove"
                type="button"
                aria-label="Удалить правило"
                title="Удалить правило"
                (click)="removePickupRule(i)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="method-footer">
              <button
                mat-button
                color="primary"
                class="add-rule"
                type="button"
                (click)="addPickupRule()"
              >
                <mat-icon>add</mat-icon>
                Другие дни
              </button>
              <span class="overlap-warning" *ngIf="duplicateDaysLabel(pickupRules) as warning">
                <mat-icon>warning</mat-icon>
                {{ warning }}
              </span>
            </div>
          </div>
        </div>

        <mat-form-field appearance="outline" class="note-box"
          ><mat-label>Заметка о доставке</mat-label>
          <textarea
            matInput
            rows="2"
            placeholder="Заметка о доставке — всё, что не влезло в правила"
            [(ngModel)]="deliveryNote"
          ></textarea>
        </mat-form-field>
      </fieldset>

      <aside class="delivery-card preview-card">
        <h2>Как увидит менеджер</h2>
        <p class="preview-receiver">
          {{
            receiverWarehouse
              ? 'Доставка на ' + receiverWarehouse.description
              : 'Выберите склад получения'
          }}
        </p>

        <ng-container *ngIf="deliveryPreview.length; else emptyPreview">
          <div class="preview-lines">
            <div *ngFor="let line of deliveryPreview">{{ line }}</div>
          </div>
          <div class="preview-eta" *ngIf="deliveryEtaPreview">
            <mat-icon>schedule</mat-icon>
            <span>{{ deliveryEtaPreview }}</span>
          </div>
        </ng-container>

        <ng-template #emptyPreview>
          <p class="empty-preview">Расписание не настроено — выберите способ доставки слева</p>
        </ng-template>

        <button
          mat-flat-button
          color="primary"
          type="button"
          [disabled]="!canEdit || !!validationError"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
          Сохранить
        </button>
      </aside>
    </main>
  </mat-tab-nav-panel>
</div>

<ng-template #unsavedDialog>
  <h2 mat-dialog-title>Сохранить изменения доставки?</h2>
  <mat-dialog-content>
    На складе {{ receiverWarehouse?.description }} остались несохраненные изменения.
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" [mat-dialog-close]="'cancel'">Отмена</button>
    <button mat-button type="button" [mat-dialog-close]="'discard'">Не сохранять</button>
    <button mat-flat-button color="primary" type="button" [mat-dialog-close]="'save'">
      Сохранить
    </button>
  </mat-dialog-actions>
</ng-template>
